import React, { Component } from 'react';
import { Route, withRouter, Switch, Redirect } from 'react-router-dom';

import TopNav from 'Containers/TopNav'
import Sidebar from 'Containers/Sidebar';

import orders from './orders';
import customers from './customers';
import system from './system';
import crm from './crm';
import reports from './reports';
import dashboards from './dashboards';
import pages from './pages';
import applications from './applications';
import ui from './ui';
import sms from './sms';
import accounting from './accounting';
import warehousing from './warehousing';

import { connect } from 'react-redux';

class MainApp extends Component {
	render() {
		const { match, containerClassnames} = this.props;
		return (
			<div id="app-container" className={containerClassnames}>
				<div className={"mobile-show"}>
					این سیستم هنوز امکان استفاده برروی موبایل را ندارد
				</div>
				<TopNav history={this.props.history} location={this.props.location} />
				<Sidebar />
				<main className={"mobile-hide"}>
					<div className="container-fluid">
						<Switch>
							<Route path={`${match.url}/warehousing`} component={warehousing} />
							<Route path={`${match.url}/accounting`} component={accounting} />
							<Route path={`${match.url}/sms`} component={sms} />
							<Route path={`${match.url}/system`} component={system} />
							<Route path={`${match.url}/crm`} component={crm} />
							<Route path={`${match.url}/reports`} component={reports} />
							<Route path={`${match.url}/customers`} component={customers} />
							<Route path={`${match.url}/orders`} component={orders} />
							<Route path={`${match.url}/applications`} component={applications} />
							<Route path={`${match.url}/dashboards`} component={dashboards} />
							<Route path={`${match.url}/pages`} component={pages} />
							<Route path={`${match.url}/ui`} component={ui} />
							<Redirect to="/error" />
						</Switch>
					</div>
				</main>
			</div>
		);
	}
}
const mapStateToProps = ({ menu }) => {
	const { containerClassnames} = menu;
	return { containerClassnames };
  }
  
export default withRouter(connect(mapStateToProps, {})(MainApp));